import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/lang";

export default function NotFound() {
  const { lang } = useLang();
  const de = lang === "de";
  const links = [
    { to: "/", label: de ? "Startseite" : "Home" },
    { to: "/services", label: de ? "Leistungen" : "Services" },
    { to: "/work", label: de ? "Projekte" : "Work" },
    { to: "/products", label: de ? "Produkte" : "Products" },
    { to: "/contact", label: de ? "Kontakt" : "Contact" },
  ];
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center pt-36 pb-24">
      <Helmet>
        <title>{de ? "Seite nicht gefunden — WERKVERDUNG" : "Page not found — WERKVERDUNG"}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="max-w-[1440px] w-full mx-auto px-6 md:px-12 lg:px-20">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-bronze">404</span>
        <h1 className="mt-6 font-serif text-5xl md:text-7xl tracking-tight text-ink leading-[1.0] max-w-3xl">
          {de ? "Diese Seite gibt es nicht." : "This page doesn't exist."}
        </h1>
        <p className="mt-6 max-w-xl text-lg text-stone">
          {de
            ? "Der Link ist vielleicht veraltet oder falsch geschrieben. Hier geht es weiter:"
            : "The link may be outdated or misspelled. Continue here:"}
        </p>
        <div className="mt-9 flex flex-wrap gap-x-8 gap-y-3">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`notfound-link-${l.to.replace(/\//g, "") || "home"}`}
              className="group inline-flex items-center gap-1.5 font-serif text-2xl text-ink hover:text-bronze transition-colors"
            >
              {l.label}
              <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
